export enum RadioPanelBorderRadius {
    None = 'noRadius',
    Small = 'smallRadius',
    Medium = 'mediumRadius',
}
